import React from 'react'
import get from 'lodash/get'
import { evalExpression } from '@/libs/functions/tpl'
import {
  LinkageOnType,
} from '../index.d'

/**
 * @param {LinkageOnType} config
 * @param {object} values
 * @returns {boolean}
 * @example  hiddenOn: { directiveType: 'evalExpression', watchFields: ['airportCode'], actuator: '!!this.airportCode' }
 */
export const isHidden = (config: LinkageOnType | undefined, values: Record<string, any>): boolean => {
  switch (config?.directiveType) {
    case 'evalExpression':
    default:
      return evalExpression(config?.actuator || '', values)
  }
}

/**
 *
 * @param  {object} prevState
 * @param  {object} nextState
 * @param  {LinkageOnType | undefined} config
 * @returns {boolean}
 */
export const shouldUpdate = (
  prevState: Record<string, any>,
  nextState: Record<string, any>,
  config: LinkageOnType | undefined,
): boolean => {
  return !!config?.watchFields?.some(
    ([fieldName]) => get(prevState, fieldName) !== get(nextState, fieldName),
  )
}

export const SchemaContext = React.createContext<Record<string, any>>({})
